import { httpClient } from '../httpClient/httpClient';

export interface ArticleTemplate {
  id: number;
  organizationId: number;
  matrixNodeXId: number;
  matrixNodeYId: number;
  name: string;
  itemCodeMinLength: number | null;
  itemCodeMaxLength: number | null;
  displayOrder: number;
  archived: boolean;
}

export interface CreateArticleTemplateRequest {
  matrixNodeXId: number | null;
  matrixNodeYId: number | null;
  name: string;
  itemCodeMinLength: number | null;
  itemCodeMaxLength: number | null;
  displayOrder: number;
}

export interface UpdateArticleTemplateRequest
  extends CreateArticleTemplateRequest {
  hasItemCodeMinLength: boolean;
  hasItemCodeMaxLength: boolean;
  archived: boolean;
}

export const articleTemplatesApi = {
  getAll: (organizationId: number) =>
    httpClient.get<ArticleTemplate[]>(
      `organizations/${organizationId}/articletemplates`,
    ),
  create: (organizationId: number, request: CreateArticleTemplateRequest) =>
    httpClient.post<ArticleTemplate>(
      `organizations/${organizationId}/articletemplates`,
      { data: request },
    ),
  update: (id: number, request: UpdateArticleTemplateRequest) =>
    httpClient.put<ArticleTemplate>(`articletemplates/${id}`, {
      data: request,
    }),
};
